/**
 * tdesign v0.44.2
 * (c) 2022 tdesign
 * @license MIT
 */

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

export { _typeof as _ };
//# sourceMappingURL=dep-dfae10c3.js.map
